module.exports = __webpack_public_path__ + "media/images/map-259c75f6.png";